<template>
  <v-form ref="form" autocomplete="off">
    <div class="d-flex align-center ga-4 mb-4">
      <h2 class="font-weight-bold">
        Proceso - {{ this.proceso }} - {{ this.descProceso }}- {{ this.sigla }}
      </h2>
      <v-divider class="mx-4" inset vertical></v-divider>
    </div>
    <!-- ================= FORMULARIO ================= -->
    <v-row>
      <v-col cols="12" md="10">
        <v-autocomplete
          v-model="editedItem.DatoAsignado"
          :items="ArrayDatos"
          :item-title="
            (ArrayDatos) => ArrayDatos.Codigo + ' - ' + ArrayDatos.Label
          "
          item-value="Codigo"
          color="primary"
          label="Dato a relacionar:"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="blue" @click="adicionarProceso"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <div align="right" class="mb-6">
      <v-btn color="green" @click="ValidateCampos"> Guardar </v-btn>
    </div>

    <!-- ================= TABLA DRAG ================= -->

    <v-card>
      <v-card>
        <v-card-title> Ordenar Procesos - Datos</v-card-title>

        <v-table height="550px">
          <thead>
            <tr>
              <th style="width: 40px"></th>
              <th style="width: 40px">Orden</th>
              <th>Dato</th>
              <th>Protegido</th>
              <th>Visible</th>
            </tr>
          </thead>

          <draggable
            v-model="items"
            tag="tbody"
            item-key="Dato"
            handle=".drag-handle"
            animation="200"
            @end="guardarOrden"
          >
            <template #item="{ element }">
              <tr>
                <td class="drag-handle">☰</td>
                <td>{{ element.OrdenDato }}</td>
                <td>{{ element.Dato }}-{{ element.DescripcionDato }}</td>
                <td>
                  <v-select
                    v-model="element.Visible"
                    :items="ArraySiNo"
                    :item-title="
                      (ArraySiNo) =>
                        ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                    "
                    item-value="Valor"
                    color="primary"
                    label="Visible:"
                    dense
                    clearable
                  >
                  </v-select>
                </td>
                <td>
                  <v-autocomplete
                    v-model="element.Protegido"
                    :items="ArraySiNo"
                    :item-title="
                      (ArraySiNo) =>
                        ArraySiNo.Valor + ' - ' + ArraySiNo.Descripcion
                    "
                    item-value="Valor"
                    color="primary"
                    label="Protegido:"
                    dense
                  >
                  </v-autocomplete>
                </td>
              </tr>
            </template>
          </draggable>
        </v-table>
      </v-card>
    </v-card>
  </v-form>

  <!-- ================= PROGRESO ================= -->

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  upsertRelacionProcesoDato,
  getRelacionProcesoDato,
} from "@/views/TCI/ProcesosP/RelacionProcesoDato/RelacionProcesoDatoService";
import { getAllDatos } from "@/views/TCI/ProcesosP/Datos/DatosService";

export default {
  name: "relacion-proceso-linea",

  components: {
    draggable,
  },

  data() {
    return {
      progreso: false,
      proceso: null,
      descProceso: null,
      sigla: null,
      editedItem: {
        DatoAsignado: null,
      },

      modelfiltro: [
        {
          campo: "Proceso",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Proceso:",
        },
      ],

      ArrayDatos: [],
      ArraySiNo: [],
      items: [],
    };
  },

  methods: {
    async ValidateCampos() {
      if (this.items.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay procesos para guardar",
        });
        return;
      }

      this.progreso = true;

      try {
        await upsertRelacionProcesoDato(this.items);

        this.$swal({
          icon: "success",
          title: "Guardado correctamente",
        });

        this.getConsultData();
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.items = [];
      this.progreso = true;
      this.modelfiltro[0].contenido = this.proceso.toString();
      this.modelfiltro[0].filtro = "=";
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: true,
      };
      try {
        const result = await getRelacionProcesoDato(data);

        // Guardamos el orden original
        this.items = result.map((item) => ({
          ...item,
          OrdenOriginal: item.OrdenDato,
          EsNuevo: false, // bandera para nuevos
        }));
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje ||
          registro.ExceptionMessage ||
          JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    guardarOrden() {
      this.items.forEach((item, index) => {
        item.OrdenDato = index + 1;
      });

      console.log("Nuevo orden:", this.items);
    },

    reset() {
      // Array si o no
      this.ArraySiNo = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 16,
      );
    },

    async adicionarProceso() {
      if (!this.editedItem.DatoAsignado) {
        this.$swal({
          icon: "warning",
          title: "Seleccione un proceso",
        });
        this.$refs.form.validate();
        return;
      }

      // Buscar el proceso completo en el array
      const datoSeleccionado = this.ArrayDatos.find(
        (p) => p.Codigo === this.editedItem.DatoAsignado,
      );

      if (!datoSeleccionado) return;

      // Evitar duplicados
      const existe = this.items.some(
        (item) => item.Dato === datoSeleccionado.Codigo,
      );

      if (existe) {
        this.$swal({
          icon: "warning",
          title: "El proceso ya fue agregado",
        });
        return;
      }

      var userperfil = this.$store.getters.userperfil;
      // Agregar a la tabla
      this.items.push({
        Proceso: this.proceso,
        Sigla: this.sigla,
        DescProceso: this.descProceso,
        Dato: datoSeleccionado.Codigo,
        DescripcionDato: datoSeleccionado.Descripcion,
        Visible: "S",
        Protegido: "N",
        OrdenDato: this.items.length + 1,
        UsuarioCreacion: userperfil.userInfo.Usuario_ID,
        UsuarioActualizacion: userperfil.userInfo.Usuario_ID,
        OrdenOriginal: null, // no tiene orden original
        EsNuevo: true, // es nuevo
      });

      // Limpiar selección
      this.editedItem.DatoAsignado = null;
    },

    // Consulta Procesos
    async getProcesos() {
      this.ArrayDatos = [];
      const result = await getAllDatos();
      this.ArrayDatos = result;
    },
  },

  mounted() {
    if (this.$route.query) {
      this.proceso = this.$route.query.procesoId;
      this.descProceso = this.$route.query.descProceso;
      this.sigla = this.$route.query.sigla;
    }

    this.reset();
    this.getConsultData();
    this.getProcesos();
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
</style>
